<template>
  <mainTemplate :showSubject="true" :nomenu="true">
    <template slot="bus">
      <question-bus v-if="showCart"></question-bus>
    </template>
    <div class="person-list">
      <div class="per-left">
        <personal-menu></personal-menu>
      </div>
      <div class="per-right">
        <transition name="slide-fade">
          <router-view />
        </transition>
      </div>
    </div>
  </mainTemplate>
</template>
<script>
import mainTemplate from '@/components/MainTemplate.vue'
import PersonalMenu from './components/PersonalMenu.vue'
import QuestionBus from '../question/components/QuestionBus.vue'

export default {
  name: 'Main',
  data() {
    return {}
  },
  components: {
    mainTemplate,
    PersonalMenu,
    QuestionBus
  },
  computed: {
    showCart() {
      if (this.$route.meta.name === 'favorite') {
        return true
      }
      return false
    }
  }
}
</script>
<style lang="scss" scoped>
.person-list {
  display: flex;
  height: 100%;
  .per-right {
    flex: 1;
    height: 100%;
  }
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
